<template>
	<div class="checkbox" :class="{ 'checked': state !== 'unchecked', 'disabled': disabled }" :style="{ 'background-color': state !== 'unchecked' ? settings.checkedColor : settings.unCheckedColor }" @click="checkboxClicked">
		<img class="checkbox-icon" v-show="state === 'checked'" src="./icons/checked.svg">
		<img class="checkbox-icon" v-show="state === 'halfChecked'" src="./icons/halfChecked.svg">
	</div>
</template>

<script>
	import _ from 'lodash'
	export default {
		name: 'Checkbox',
		props: {
			modelValue: {},
			options: {},
			isHalf: { default: false, type: Boolean },
			disabled: { default: false, type: Boolean }
		},
		emits: ['update:modelValue', 'click'],
		data() {
			return {
				settings: {
					checkedColor: '#466eb5',
					unCheckedColor: 'white'
				},
				state: 'unchecked', // checked unchecked halfChecked
			}
		},
		watch: {
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					this.state = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				}
			}
		},
		created() {
			if (this.modelValue)
				this.state = this.modelValue
		},
		mounted() {
		},
		methods: {
			checkboxClicked() {
				if (this.disabled) return
				switch (this.state) {
					case 'checked':
						this.state = 'unchecked'
						break
					case 'unchecked':
					case 'halfChecked':
						this.state = 'checked'
						break
				}

				this.$emit('update:modelValue', this.state === 'checked' ? true : false)
				this.$emit('click')
			}
		}
	}
</script>

<style scoped>
	.checkbox {
		width: 25px;
		height: 25px;
		border: 1px solid #dadada;
		border-radius: 4px;
		padding: 2px;
		display: inline-block;
		margin: 0px 4px;
		background-color: white;
		transition: background-color 0.2s ease-in-out;
	}

	.checkbox img {
		width: 100%;
		height: 100%;
	}

	.checkbox-icon {
		animation: checbkoxAnimation 0.2s ease-in-out forwards;
	}

	.checkbox.disabled {
		cursor: not-allowed;
		opacity: 0.5;
		pointer-events: none;
	}

	@keyframes checbkoxAnimation {
		from {
			opacity: 0;
			transform: rotate(20deg);
		}

		to {
			opacity: 1;
			transform: rotate(0deg);
		}
	}
</style>